import { c as _c } from "react/compiler-runtime";
import { CARD_BRAND_ICONS, PAYPAL_ICON } from "@/lib/payment/cardBrands";
const METHODS = [...CARD_BRAND_ICONS, PAYPAL_ICON];
export function PaymentMethodIcons() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex gap-2 py-4">{METHODS.map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(method) {
  return <img key={method.name} src={method.src} alt={method.name} className="h-6 lg:h-7" />;
}